import { CreditCardQueryResponse } from '../api'

type MaybeCreditCardQueryResponse = CreditCardQueryResponse | undefined

/**
 * Sets the "presented" property of the "offerDetails" object in the "customerCardOffer" object
 * to true if it exists in the cache. If not, returns the original cache unmodified.
 *
 * @param {MaybeCreditCardQueryResponse} cache The cache containing the credit card offer data
 * @returns {MaybeCreditCardQueryResponse} The updated cache with the "presented" property set to true
 */
export const setCreditOfferCacheToPresented = (
  cache: MaybeCreditCardQueryResponse,
): MaybeCreditCardQueryResponse => {
  return cache?.customerCardOffer
    ? {
        customerCardOffer: {
          ...cache.customerCardOffer,
          offerDetails: {
            ...cache.customerCardOffer.offerDetails,
            presented: true,
          },
        },
      }
    : cache
}
